import React, { useState, useEffect } from "react";
import {
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
} from "recharts";
import useInterval from "@rooks/use-interval";
// import CustomTooltip from "../../../utils/CustomTooltip";

// import axios from "axios";
import axios from "../../../api/axios";
import clsx from "clsx";
import Calendar from "../../../icons/Calendar";

var request_updateTimelineData_safe = true;

function paddingZeroLeft(num) {
  return parseInt(num) < 10 ? "0" + num : num;
}

function getCurrentWeek() {
  let firstDayOfWeek = new Date();
  firstDayOfWeek = firstDayOfWeek.setDate(
    firstDayOfWeek.getDate() - firstDayOfWeek.getDay()
  );
  let lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek = lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);

  return (
    paddingZeroLeft(new Date(firstDayOfWeek).getDate()) +
    "/" +
    paddingZeroLeft(new Date(firstDayOfWeek).getMonth() + 1) +
    " - " +
    paddingZeroLeft(new Date(lastDayOfWeek).getDate()) +
    "/" +
    paddingZeroLeft(new Date(lastDayOfWeek).getMonth() + 1)
  );
}

const CustomTooltips = ({ active, payload, label }) => {
  // console.log(`payload ${payload} `);

  if (active && payload && payload.length) {
    if (
      payload[0] &&
      payload[1] &&
      payload[0].value === 0 &&
      payload[1].value === 0
    ) {
      return null;
    } else if (payload[0] && payload[0].value === 0) {
      return null;
    } else if (payload[1] && payload[1].value === 0) {
      return null;
    }
    let currentDay = payload[0].payload.day.split("/");

    return (
      <div className="bg-white shadow-xl p-4 text-sm border rounded-md space-y-1 animate-fadeIn">
        <p className="font-bold">
          {new Date(
            currentDay[1] +
              "/" +
              currentDay[0] +
              "/" +
              new Date().getUTCFullYear()
          ).toDateString()}
        </p>
        {payload[3] && (
          <p
            className={clsx({
              "text-blue-500": payload[3].dataKey === "westToEastCount",
            })}
          >{`West To East : ${payload[3].value.toLocaleString()}`}</p>
        )}
        {payload[2] && (
          <p
            className={clsx({
              "text-green-500": payload[2].dataKey === "eastToWestCount",
            })}
          >{`East To West : ${payload[2].value.toLocaleString()}`}</p>
        )}
        {payload[1] && (
          <p
            className={clsx({
              "text-red-500": payload[1].dataKey === "eastToNorthCount",
            })}
          >{`East To North  : ${payload[1].value.toLocaleString()}`}</p>
        )}
        {payload[0] && (
          <p
            className={clsx({
              "text-yellow-500 opacity-80 ":
                payload[0].dataKey === "northToEestCount",
            })}
          >{`North To East : ${payload[0].value.toLocaleString()}`}</p>
        )}

        {/* <p className="text-gray-400">Total: {totalVisits.toLocaleString()}</p> */}
      </div>
    );
  }

  return null;
};

const BarChartWeeklyStatistics = ({ token }) => {
  const [timelineData, setTimelineData] = useState([
    {
      day: "0/0",
      northToEestCount: 0,
      eastToNorthCount: 0,
      eastToWestCount: 0,
      westToEastCount: 0,
      Total: 0,
      currentDay: 0,
    },
  ]);

  const [finishSetup, setFinishSetup] = useState(false);
  const [currentWeek, setCurrentWeek] = useState("--");
  const [loading, setLoading] = useState(true);

  function updateTimelineDataAllWeek() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    let first_day_of_week = new Date();
    first_day_of_week = first_day_of_week.setDate(
      first_day_of_week.getDate() - first_day_of_week.getDay()
    );
    let resPromises = [];
    let day = [];

    for (let i = 0; i < 7; i++) {
      let current_day_search = new Date(first_day_of_week);
      current_day_search = current_day_search.setDate(
        current_day_search.getDate() + i
      );
      day.push(current_day_search);
      resPromises.push(
        axios.get(
          `/v1/statistics/day/vehicles?token=${token}&day=${new Date(
            current_day_search
          ).getUTCDate()}&month=${
            new Date(current_day_search).getUTCMonth() + 1
          }&areas=null`,
          {
            withCredentials: true,
          }
        )
      );
    }
    Promise.all(resPromises)
      .then((res) => {
        let resData = [];
        res.forEach((data, index) => {
          let northToEestCount = 0;
          let eastToNorthCount = 0;
          let eastToWestCount = 0;
          let westToEastCount = 0;
          let total = 0;
          for (let j = 0; j < data.data.length; j++) {
            northToEestCount += data.data[j]["northToEestCount"]
              ? data.data[j]["northToEestCount"]
              : 0;
            eastToNorthCount += data.data[j]["eastToNorthCount"]
              ? data.data[j]["eastToNorthCount"]
              : 0;
            eastToWestCount += data.data[j]["eastToWestCount"]
              ? data.data[j]["eastToWestCount"]
              : 0;
            westToEastCount += data.data[j]["westToEastCount"]
              ? data.data[j]["westToEastCount"]
              : 0;
            total +=
              northToEestCount +
              eastToNorthCount +
              eastToWestCount +
              westToEastCount;
          }
          resData.push({
            day:
              paddingZeroLeft(new Date(day[index]).getDate()) +
              "/" +
              paddingZeroLeft(new Date(day[index]).getMonth() + 1),
            northToEestCount: northToEestCount,
            eastToNorthCount: eastToNorthCount,
            eastToWestCount: eastToWestCount,
            westToEastCount: westToEastCount,
            Total: total,
            currentDay: day[index],
          });
          resData.sort((a, b) =>
            parseInt(a["currentDay"]) > parseInt(b["currentDay"]) ? 1 : -1
          );
        });
        if (resData.length === 7) {
          setTimelineData((prev) => [...resData]);
          setFinishSetup(true);
        }
      })
      .catch((err) => console.error(err));
    // finished.forEach((res, index) => {
    //   let northToEestCount = 0;
    //   let eastToNorthCount = 0;
    //   let eastToWestCount = 0;
    //   let westToEastCount = 0;
    //   let total = 0;
    //   for (let j = 0; j < res.data.length; j++) {
    //     northToEestCount += res.data[j]["northToEestCount"]
    //       ? res.data[j]["northToEestCount"]
    //       : 0;
    //     eastToNorthCount += res.data[j]["eastToNorthCount"]
    //       ? res.data[j]["eastToNorthCount"]
    //       : 0;
    //     eastToWestCount += res.data[j]["eastToWestCount"]
    //       ? res.data[j]["eastToWestCount"]
    //       : 0;
    //     westToEastCount += res.data[j]["westToEastCount"]
    //       ? res.data[j]["westToEastCount"]
    //       : 0;
    //     total +=
    //       northToEestCount +
    //       eastToNorthCount +
    //       eastToWestCount +
    //       westToEastCount;
    //   }
    //   console.log(index);
    //   resData.push({
    //     day:
    //       paddingZeroLeft(new Date(day[index]).getDate()) +
    //       "/" +
    //       paddingZeroLeft(new Date(day[index]).getMonth() + 1),
    //     northToEestCount: northToEestCount,
    //     eastToNorthCount: eastToNorthCount,
    //     eastToWestCount: eastToWestCount,
    //     westToEastCount: westToEastCount,
    //     Total: total,
    //     currentDay: day[index],
    //   });
    //   resData.sort((a, b) =>
    //     parseInt(a["currentDay"]) > parseInt(b["currentDay"]) ? 1 : -1
    //   );
    // });
    request_updateTimelineData_safe = true;
  }

  // Get the data for the in-out chart for the first time
  useEffect(() => {
    updateTimelineDataAllWeek();
    setTimeout(() => {
      setLoading(false);
    }, 4500);
  }, []); // eslint-disable-line

  // Get current week
  useEffect(() => {
    setCurrentWeek(getCurrentWeek());
  }, []); // eslint-disable-line

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      if (finishSetup) {
        // updateTimelineDataToday();
        updateTimelineDataAllWeek();
      } else {
        updateTimelineDataAllWeek();
      }
    },
    60000,
    true
  );

  if (loading) {
    return (
      <div className="bg-gray-300 flex-col h-full  rounded-md overflow-hidden transition-all self-baseline ">
        <div className="w-120 h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
      </div>
    );
  }
  return (
    <div className="pt-2 flex flex-col justify-around">
      <div className="flex items-stretch mb-2 ml-2 space-x-2">
        <div className="border-b-2 border-l-2 font-bold text-lg border-gray-400 border-opacity-20 px-2 shadow-sm  text-gray-600 ">
          Total Vehicles Per Day Current Week
        </div>
        <div className="text-xs font-medium text-gray-400 text-center p-1 px-2 flex flex-row border border-gray-300 rounded-md space-x-2 bg-opacity-90 items-center select-none">
          <div>
            <Calendar />
          </div>
          <div>{currentWeek}</div>
        </div>
      </div>
      <div className=" lg:h-80 xl:h-80 2xl:h-80  2xl:mt-6 ">
        <ResponsiveContainer>
          <BarChart
            data={timelineData}
            margin={{ top: 15, right: 10, left: 20, bottom: 0 }}
          >
            <defs>
              <linearGradient id="northToEestCount" x1="0" y1="0" x2="0" y2="1">
                <stop offset="100%" stopColor="rgb(247, 202, 22)" />
              </linearGradient>
              <linearGradient id="eastToNorthCount" x1="0" y1="0" x2="0" y2="1">
                <stop offset="100%" stopColor="rgb(207, 19, 91)" />
              </linearGradient>
              <linearGradient id="westToEastCount" x1="0" y1="0" x2="0" y2="1">
                <stop offset="100%" stopColor="rgb(59, 130, 246)" />
              </linearGradient>
              <linearGradient id="eastToWestCount" x1="0" y1="0" x2="0" y2="1">
                <stop offset="100%" stopColor="rgba(52, 211, 153)" />
              </linearGradient>

              {/* <linearGradient id="Total" x1="0" y1="0" x2="0" y2="1">
                <stop offset="100%" stopColor="rgb(156, 163, 175)" />
              </linearGradient> */}
            </defs>
            <Tooltip
              coordinate={{ x: 0, y: 0 }}
              offset={-50}
              allowEscapeViewBox={{ x: true, y: true }}
              content={<CustomTooltips />}
              // content={({ active, payload, label }) => {
              //   console.log(payload);
              // }}
              // formatter={(Total) => new Intl.NumberFormat("en").format(Total)}
              // // formatter={<customFormatter />}
              cursor={false}
            />
            <XAxis
              axisLine={false}
              tick={{ fontSize: "0.6rem" }}
              interval="preserveStartEnd"
              height={15}
              dataKey="day"
            />
            <YAxis
              axisLine={false}
              tickLine={true}
              tick={{
                fontSize: "0.6rem",
              }}
              width={30}
              interval="preserveStartEnd"
              dataKey="Total"
              tickFormatter={(value) =>
                new Intl.NumberFormat("en").format(value)
              }
            />
            {
              <Bar
                dataKey="northToEestCount"
                stackId={"a"}
                fill={"url(#northToEestCount)"}
              >
                {/* <LabelList
                  dataKey="northToEestCount"
                  fill="#3886fc"
                  fontSize={"0.6rem"}
                  position={"top"}
                  formatter={(value) =>
                    new Intl.NumberFormat("en").format(value)
                  }
                ></LabelList> */}
              </Bar>
            }
            {
              <Bar
                dataKey="eastToNorthCount"
                stackId={"a"}
                fill={"url(#eastToNorthCount)"}
              >
                {/* <LabelList
                  dataKey="eastToNorthCount"
                  fill="#3886fc"
                  fontSize={"0.6rem"}
                  position={"top"}
                  formatter={(value) =>
                    new Intl.NumberFormat("en").format(value)
                  }
                ></LabelList> */}
              </Bar>
            }
            {
              <Bar
                dataKey="eastToWestCount"
                stackId={"a"}
                fill={"url(#eastToWestCount)"}
              >
                {/* <LabelList
                  dataKey="eastToWestCount"
                  fill="rgba(52, 211, 153)"
                  fontSize={"0.6rem"}
                  position={"top"}
                  formatter={(value) =>
                    new Intl.NumberFormat("en").format(value)
                  }
                ></LabelList> */}
              </Bar>
            }
            {
              <Bar
                dataKey="westToEastCount"
                stackId={"a"}
                fill={"url(#westToEastCount)"}
              >
                {/* <LabelList
                  dataKey="westToEastCount"
                  fill="rgb(59, 130, 246)"
                  fontSize={"0.6rem"}
                  position={"top"}
                  formatter={(value) =>
                    new Intl.NumberFormat("en").format(value)
                  }
                ></LabelList> */}
              </Bar>
            }
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BarChartWeeklyStatistics;
